import * as React from "react";
import { cn } from "@/lib/utils/cn";
import { Container } from "./container";

export function Section({
  id,
  className,
  children,
}: {
  id?: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <section id={id} className={cn("scroll-mt-24 py-16 sm:py-24", className)}>
      <Container>{children}</Container>
    </section>
  );
}
